import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
    card: {
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        minWidth: 0,
        color: theme.palette.text.primary,
        '&:hover $poster, &:focus-visible $poster': {
            transform: 'translateY(-6px)',
        },
        '&:hover $overlay, &:focus-visible $overlay': {
            opacity: 1,
        },
    },
    poster: {
        position: 'relative',
        aspectRatio: '2 / 3',
        maxWidth: '100%',
        borderRadius: 12,
        overflow: 'hidden',
        background: theme.palette.raised,
        boxShadow: theme.palette.mode === 'dark'
            ? '0 18px 40px -18px rgba(0, 0, 0, 0.8)'
            : '0 18px 40px -22px rgba(40, 20, 60, 0.35)',
        transition: 'transform 0.25s ease',
    },
    image: {
        position: 'absolute',
        inset: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    },
    badge: {
        position: 'absolute',
        top: 10,
        left: 10,
        display: 'inline-flex',
        alignItems: 'center',
        gap: 3,
        padding: '3px 8px',
        borderRadius: 6,
        background: 'rgba(10, 10, 14, 0.78)',
        backdropFilter: 'blur(4px)',
        color: '#fff',
        fontFamily: theme.fonts.mono,
        fontSize: 12,
        fontWeight: 500,
    },
    type: {
        position: 'absolute',
        top: 10,
        right: 10,
        padding: '3px 7px',
        borderRadius: 6,
        background: 'rgba(10, 10, 14, 0.78)',
        backdropFilter: 'blur(4px)',
        color: '#fff',
        fontFamily: theme.fonts.mono,
        fontSize: 10.5,
        fontWeight: 600,
        letterSpacing: '0.1em',
        textTransform: 'uppercase',
    },
    typeTv: {
        background: theme.palette.primary.main,
    },
    star: {
        fontSize: '13px !important',
        color: '#f5c518',
    },
    overlay: {
        position: 'absolute',
        inset: 0,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        gap: 8,
        padding: 14,
        color: '#fff',
        background: 'linear-gradient(0deg, rgba(10, 10, 14, 0.94) 0%, rgba(10, 10, 14, 0.55) 55%, transparent 100%)',
        opacity: 0,
        transition: 'opacity 0.25s',
    },
    overview: {
        fontSize: 12,
        lineHeight: 1.45,
        display: '-webkit-box',
        WebkitLineClamp: 5,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
    },
    more: {
        fontSize: 12,
        fontWeight: 700,
        color: '#ff3b5c',
    },
    title: {
        fontSize: 14,
        fontWeight: 700,
        lineHeight: 1.3,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    sub: {
        marginTop: -6,
        fontSize: 12,
        color: theme.palette.text.secondary,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
}));
